import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { store, persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { setTokenGetter, setLogoutHandler } from './services/HTTP'; //
import { clearAuth } from './store/features/auth/authSlice';

const root = ReactDOM.createRoot(document.getElementById('root'));

const handleBeforeLift = () => {
  setTokenGetter(() => store.getState().auth.token);
  setLogoutHandler(() => {
    try {
      store.dispatch(clearAuth());
    } catch (e) {
      console.warn('Failed to dispatch clearAuth from index.js', e);
    }
    window.location.href = '/';
  });
};

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor} onBeforeLift={handleBeforeLift}>
      <App />
      <ToastContainer position="top-right" autoClose={3000} />
    </PersistGate>
  </Provider>
);

reportWebVitals();
